import PromoBYDSealion7 from "../../../images/promo/oct26/PromoBYDSealion7.png";
import PromoBYDSealion7Mobile from "../../../images/promo/oct26/PromoBYDSealion7Mobile.png";
import PromoTeslaY from "../../../images/promo/oct26/PromoTeslaY.png";
import PromoTeslaYMobile from "../../../images/promo/oct26/PromoTeslaYMobile.png";
import PromoZeekr7X from "../../../images/promo/oct26/PromoZeekr7X.png";
import PromoZeekr7XMobile from "../../../images/promo/oct26/PromoZeekr7XMobile.png";
import PromoMazda6 from "../../../images/promo/oct26/PromoMazda6.png";
import PromoMazda6Mobile from "../../../images/promo/oct26/PromoMazda6Mobile.png";
import PromoNissanNavara from "../../../images/promo/oct26/PromoNissanNavara.png";
import PromoNissanNavaraMobile from "../../../images/promo/oct26/PromoNissanNavaraMobile.png";
import PromoPolestar2 from "../../../images/promo/oct26/PromoPolestar2.png";
import PromoPolestar2Mobile from "../../../images/promo/oct26/PromoPolestar2Mobile.png";
import PromoDenzaB5 from "../../../images/promo/oct26/PromoDenzaB5.png";
import PromoDenzaB5Mobile from "../../../images/promo/oct26/PromoDenzaB5Mobile.png";

const dataSlider = (hidePartnered) => [
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: true,
        hideBanner: hidePartnered, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "",
        priceCents: "",
        period: "",
        priceNote: "",
        disclaimerText: "",
        image: "",
        imageMobile: "",
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "$4,000 Cashback",
        vehicleTitle:
            "Select BYD Models (Seal 6, Sealion 5, Sealion 6, Sealion 8, Sealion 7 & Shark 6)",
        vehicleSubTitle:
            "$4,000 cashback for orders placed between 1st October to 31st December 2026, and delivered by 31st December 2026!",
        fromText: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        priceNote: "",
        disclaimerText:
            "*Eligible for Novated Lease buyers. Excludes commercial fleet, demos, service loaners, or combined promo offers.",
        termsLinkUrl: "",
        image: PromoBYDSealion7,
        imageMobile: PromoBYDSealion7Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "$2,000 Cashback",
        vehicleTitle: "Mazda 6e & CX-6e",
        vehicleSubTitle:
            "$2,000 cashback for purchases placed and delivered via novated lease between 1st October to 31st December 2026! National Drive-Away Pricing included.",
        fromText: "from",
        priceDollar: "185",
        priceCents: "",
        period: "weekly*",
        priceNote: "Mazda 6e GT from $185/wk | Mazda CX-6e GT from $200/wk",
        disclaimerText:
            "*Cashback provided by participating Mazda dealers on eligible novated lease deliveries. Must be purchased through a local PMA client dealer. T&Cs apply.",
        termsLinkUrl: "",
        image: PromoMazda6,
        imageMobile: PromoMazda6Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Tesla Model Y Premium RWD",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "226",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Weekly price assumes a 5 year lease (NSW, $100k salary, 15k km/yr).",
        termsLinkUrl: "",
        image: PromoTeslaY,
        imageMobile: PromoTeslaYMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "Customer Favourites",
        vehicleTitle: "Zeekr 7X",
        vehicleSubTitle: "",
        fromText: "from",
        priceDollar: "217",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "* Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year.",
        termsLinkUrl: "",
        image: PromoZeekr7X,
        imageMobile: PromoZeekr7XMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "$16,079 Exclusive Savings",
        vehicleTitle: "Nissan Navara 4X4 PRO-4X Auto",
        vehicleSubTitle:
            "NLA Exclusive Total Combined Discount of $16,079! Valid 1 October to 31 December 2026.",
        fromText: "from",
        priceDollar: "278",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "*Includes Nissan's 10-year / 300,000 km warranty (conditions apply). On-road costs, dealer delivery, statutory charges, and metallic paint are additional.",
        termsLinkUrl: "",
        image: PromoNissanNavara,
        imageMobile: PromoNissanNavaraMobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "12% Fleet Discount",
        vehicleTitle: "MY26 / MY27 Polestar 2 Range (SRSM, LRSM, LRDM & LRDMP)",
        vehicleSubTitle:
            "12% fleet discount available across all MY26 and MY27 Polestar 2 variants!",
        fromText: "from",
        priceDollar: "217",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "*Campaign period: 1 Oct 2026 - 31 Dec 2026 (or while stock lasts). Order deadline: 31 Dec 2026, 11:59pm AEST. Delivery deadline: 31 Jan 2027 (excludes BTO orders).",
        termsLinkUrl: "",
        image: PromoPolestar2,
        imageMobile: PromoPolestar2Mobile,
    },
    {
        isTextImage: true,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "15% Off Discount",
        vehicleTitle: "MY25 DENZA B5 & B5 Leopard",
        vehicleSubTitle:
            "15% off special novated leasing discount for MY25 DENZA B5 and B5 Leopard models delivered by 31st October!",
        fromText: "from",
        priceDollar: "324",
        priceCents: "",
        period: "weekly*",
        priceNote: "",
        disclaimerText:
            "*Offer valid for MY25 DENZA B5 and B5 Leopard orders delivered by 31 October 2026. T&Cs apply.",
        termsLinkUrl: "",
        image: PromoDenzaB5,
        imageMobile: PromoDenzaB5Mobile,
    },
];

export default dataSlider;
